"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DisabledEditorManager = (function () {
    function DisabledEditorManager() {
        this._disabledEditors = new Array();
    }
    DisabledEditorManager.prototype.setEditorEnabled = function (grid, row, path, state) {
        if (state === true) {
            _.remove(this._disabledEditors, function (cand) {
                return (cand.row === row && cand.path === path);
            });
        }
        else {
            this._disabledEditors.push({ row: row, path: path });
        }
    };
    DisabledEditorManager.prototype.isEnabled = function (column, row) {
        var result = _.findIndex(this._disabledEditors, function (candidate) {
            return candidate.row === row && candidate.path === column.dataPath;
        });
        return result === -1;
    };
    return DisabledEditorManager;
}());
exports.DisabledEditorManager = DisabledEditorManager;
//# sourceMappingURL=disabledEditorManager.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/disabledEditorManager.js
// module id = 24
// module chunks = 0